module.exports = __webpack_public_path__ + "static/media/no-ticket.c3a77785.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/no-ticket.svg
// module id = 167
// module chunks = 0